import React from 'react';
import { useNavigate } from 'react-router-dom';

function TermsPage() {
  const navigate = useNavigate();

  const sectionStyle = { marginBottom: '28px' };
  const h2Style = { color: 'var(--primary)', fontSize: '20px', marginBottom: '12px', fontWeight: '700' };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>وِداد</h1>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '800px' }}>
        <div className="card fade-in" style={{ padding: '36px 28px', borderRadius: '20px' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h1 style={{ fontSize: '28px', color: 'var(--text-dark)', marginBottom: '8px' }}>
              الشروط والأحكام
            </h1>
            <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
              آخر تحديث: مايو 2026
            </p>
          </div>

          <div style={{ lineHeight: '2', color: 'var(--text-dark)', fontSize: '15px' }}>
            
            {/* English Service Description - For Payment Gateway Review */}
            <section style={{ 
              ...sectionStyle, 
              background: 'rgba(0, 137, 123, 0.06)',
              border: '1px solid rgba(0, 137, 123, 0.2)',
              borderRadius: '12px',
              padding: '20px',
              direction: 'ltr',
              textAlign: 'left'
            }}>
              <h2 style={{ ...h2Style, fontSize: '17px' }}>Service Description (English)</h2>
              <p style={{ fontSize: '14px', lineHeight: '1.8' }}>
                <strong>Widad</strong> is a <strong>membership-based matrimonial networking community</strong> designed
                exclusively for Muslims who are <strong>seriously seeking marriage</strong> in accordance with Islamic principles.
                The platform operates as a <strong>relationship coaching and matchmaking service</strong> that helps verified
                adult members (18+) discover compatible life partners through structured profile matching, guided
                communication, and value-based filtering.
              </p>
              <p style={{ fontSize: '14px', lineHeight: '1.8', marginTop: '10px' }}>
                <strong>What we are NOT:</strong> Widad is not a casual dating platform, hookup service, or social
                entertainment app. All interactions are governed by Islamic values, family involvement is encouraged,
                and the sole purpose is <strong>halal marriage</strong>.
              </p>
              <p style={{ fontSize: '14px', lineHeight: '1.8', marginTop: '10px' }}>
                <strong>Membership tiers:</strong> Free (limited messaging), Weekly Premium (19 SAR),
                Monthly Premium (69 SAR), Yearly Premium (299 SAR). All prices in Saudi Riyal. All paid plans grant
                unlimited messaging, advanced search, and AI-powered compatibility suggestions.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>بسم الله الرحمن الرحيم</h2>
              <p>
                مرحباً بك في منصة <strong>وِداد</strong> للزواج الشرعي. باستخدامك لهذه المنصة، فإنك توافق على الالتزام بجميع الشروط والأحكام المذكورة أدناه. يرجى قراءتها بعناية قبل الاستمرار.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>1. الهدف من المنصة (Service Purpose)</h2>
              <p>
                منصة وِداد هي <strong>مجتمع عضوية للتوفيق في الزواج الشرعي</strong> (Membership-Based Matrimonial
                Community)، متخصصة في التوفيق بين الراغبين الجادين في الزواج الشرعي وفق أحكام الشريعة الإسلامية.
                نقدم خدمات <strong>التدريب على بناء العلاقات الناجحة والتوفيق الجاد</strong>
                (Relationship Coaching &amp; Matchmaking) في بيئة آمنة ومحترمة.
              </p>
              <p style={{ marginTop: '8px' }}>
                المنصة <strong>ليست</strong> موقع تعارف عابر أو ترفيهي، بل مجتمع عضوية مغلق للراشدين البالغين (+18)
                الجادين في الزواج فقط.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>2. شروط العضوية</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>أن يكون المستخدم بالغاً راشداً (18 سنة فأكثر)</li>
                <li style={{ marginBottom: '6px' }}>أن يكون جاداً في نية الزواج الشرعي</li>
                <li style={{ marginBottom: '6px' }}>أن يكون صادقاً في جميع المعلومات المقدمة</li>
                <li style={{ marginBottom: '6px' }}>أن يلتزم بالأدب والأخلاق الإسلامية في التعامل</li>
                <li style={{ marginBottom: '6px' }}>أن يحترم خصوصية الآخرين ولا ينشر معلوماتهم</li>
                <li style={{ marginBottom: '6px' }}>ألا يكون قد تم حظره مسبقاً من المنصة</li>
              </ul>
            </section>

            <section style={{ 
              ...sectionStyle, 
              background: 'rgba(0, 137, 123, 0.08)', 
              padding: '20px', 
              borderRadius: '12px',
              border: '1px solid rgba(0, 137, 123, 0.15)'
            }}>
              <h2 style={h2Style}>3. قواعد السلوك والآداب الإسلامية</h2>
              <p style={{ marginBottom: '12px' }}>يلتزم جميع المستخدمين بما يلي:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}><strong>الصدق والأمانة:</strong> تقديم معلومات صحيحة ودقيقة في الملف الشخصي</li>
                <li style={{ marginBottom: '6px' }}><strong>الاحترام المتبادل:</strong> التعامل بأدب واحترام مع جميع المستخدمين</li>
                <li style={{ marginBottom: '6px' }}><strong>الحشمة والوقار:</strong> الالتزام بالحشمة في الصور والمحادثات</li>
                <li style={{ marginBottom: '6px' }}><strong>الجدية:</strong> عدم العبث أو إضاعة وقت الآخرين</li>
                <li style={{ marginBottom: '6px' }}><strong>النية الصادقة:</strong> استخدام المنصة بنية الزواج الشرعي فقط</li>
              </ul>
            </section>

            <section style={{ 
              ...sectionStyle, 
              background: 'rgba(211, 47, 47, 0.08)', 
              padding: '20px', 
              borderRadius: '12px',
              border: '2px solid rgba(211, 47, 47, 0.3)'
            }}>
              <h2 style={{ ...h2Style, color: 'var(--error)' }}>4. المحظورات (تؤدي إلى شطب العضوية فوراً)</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '8px' }}><strong>تبادل أرقام الجوال أو وسائل التواصل:</strong> يُمنع منعاً باتاً تبادل أرقام الهواتف أو حسابات التواصل الاجتماعي قبل إتمام الخطوبة الرسمية</li>
                <li style={{ marginBottom: '8px' }}><strong>الكلام الفاحش أو غير اللائق:</strong> أي عبارات خادشة للحياء أو مخالفة للآداب الإسلامية</li>
                <li style={{ marginBottom: '8px' }}><strong>الصور غير اللائقة:</strong> رفع صور مخالفة للحشمة الشرعية</li>
                <li style={{ marginBottom: '8px' }}><strong>الاحتيال والخداع:</strong> تقديم معلومات كاذبة أو انتحال شخصية</li>
                <li style={{ marginBottom: '8px' }}><strong>التحرش أو الإزعاج:</strong> إرسال رسائل مزعجة أو متكررة بعد الرفض</li>
                <li style={{ marginBottom: '8px' }}><strong>استخدام المنصة لأغراض غير شرعية:</strong> أي استخدام مخالف للشريعة الإسلامية</li>
                <li style={{ marginBottom: '8px' }}><strong>الترويج أو الإعلان:</strong> استخدام المنصة للترويج لمنتجات أو خدمات</li>
              </ul>
              <p style={{ 
                marginTop: '16px', padding: '12px', 
                background: 'rgba(211, 47, 47, 0.1)', borderRadius: '8px',
                fontWeight: '600', color: 'var(--error)'
              }}>
                تنبيه: مخالفة أي من البنود أعلاه تؤدي إلى شطب العضوية فوراً ودون إنذار مسبق، مع احتفاظ الإدارة بحق اتخاذ الإجراءات القانونية اللازمة.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>5. آلية التواصل الصحيحة</h2>
              <ol style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>البحث عن ملفات متوافقة مع معاييرك</li>
                <li style={{ marginBottom: '6px' }}>إرسال طلب تواصل عبر المنصة</li>
                <li style={{ marginBottom: '6px' }}>في حال القبول، يتم التواصل عبر رسائل المنصة فقط</li>
                <li style={{ marginBottom: '6px' }}>عند الجدية، يتم ترتيب لقاء رسمي بحضور الولي</li>
                <li style={{ marginBottom: '6px' }}>بعد الخطوبة الرسمية يمكن تبادل وسائل التواصل</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>6. سياسة الصور</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>يجب أن تكون الصور حقيقية وحديثة للمستخدم نفسه</li>
                <li style={{ marginBottom: '6px' }}>يجب أن تكون الصور ملتزمة بالحشمة الشرعية</li>
                <li style={{ marginBottom: '6px' }}>للأخوات: يُفضل صور بالحجاب الشرعي</li>
                <li style={{ marginBottom: '6px' }}>تخضع جميع الصور للمراجعة قبل النشر</li>
                <li style={{ marginBottom: '6px' }}>يحق للإدارة رفض أي صورة غير مناسبة</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>7. الاشتراكات والمدفوعات</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>الاشتراك المجاني يتضمن: طلبات تواصل غير محدودة ورسالة واحدة مجانية لكل محادثة</li>
                <li style={{ marginBottom: '6px' }}>الاشتراك المميز يوفر رسائل غير محدودة وميزات إضافية</li>
                <li style={{ marginBottom: '6px' }}>يحق للمشترك طلب استرداد المبلغ خلال 30 يوماً من تاريخ الاشتراك (راجع <span onClick={() => navigate('/refund-policy')} style={{ color: 'var(--primary)', cursor: 'pointer', textDecoration: 'underline' }}>سياسة الاسترداد</span>)</li>
                <li style={{ marginBottom: '6px' }}>في حال شطب العضوية بسبب مخالفة، لا يُسترد المبلغ</li>
                <li style={{ marginBottom: '6px' }}>يمكن إلغاء الاشتراك في أي وقت دون رسوم إضافية</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>8. الملكية الفكرية</h2>
              <p>
                جميع محتويات المنصة بما في ذلك التصميم والشعار والنصوص والبرمجيات هي ملكية حصرية لمنصة وِداد. يُمنع نسخ أو إعادة إنتاج أي جزء من المنصة دون إذن كتابي مسبق.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>9. إخلاء المسؤولية</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>المنصة وسيلة توفيق بين الراغبين في الزواج فقط، ولا تضمن نجاح أي ارتباط أو إتمام أي زواج</li>
                <li style={{ marginBottom: '6px' }}>المستخدم مسؤول عن التحقق من صدق الطرف الآخر</li>
                <li style={{ marginBottom: '6px' }}>ننصح بالتحري والسؤال قبل اتخاذ قرار الزواج</li>
                <li style={{ marginBottom: '6px' }}>المنصة غير مسؤولة عن أي أضرار ناتجة عن سوء الاستخدام</li>
                <li style={{ marginBottom: '6px' }}>نبذل قصارى جهدنا لتوفير خدمة مستمرة لكن لا نضمن خلوها من الأعطال التقنية</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>10. القانون المعمول به</h2>
              <p>
                تخضع هذه الشروط والأحكام لأنظمة وقوانين المملكة العربية السعودية. أي نزاع ينشأ يُحال إلى الجهات القضائية المختصة في المملكة العربية السعودية.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>11. تعديل الشروط</h2>
              <p>
                يحق لإدارة منصة وِداد تعديل هذه الشروط والأحكام في أي وقت. سيتم إشعار المستخدمين بأي تعديلات جوهرية. استمرارك في استخدام المنصة يعني موافقتك على الشروط المحدثة.
              </p>
            </section>

            <section style={{ 
              background: 'rgba(0, 137, 123, 0.08)', 
              padding: '20px', borderRadius: '12px', textAlign: 'center'
            }}>
              <h2 style={h2Style}>تواصل معنا</h2>
              <p>
                لأي استفسارات أو شكاوى، يرجى التواصل عبر:<br/>
                <strong style={{ color: 'var(--primary)' }}>help@wedad.online</strong>
              </p>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/contact')}
                style={{ marginTop: '12px', padding: '10px 24px', fontSize: '14px' }}
              >
                صفحة اتصل بنا
              </button>
            </section>
          </div>

          <button 
            className="btn btn-primary"
            onClick={() => navigate(-1)}
            style={{ marginTop: '24px', width: '100%' }}
          >
            رجوع
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
